import { imageJobsRoutes } from '@areas/image-jobs';
import { clientImageTemplatesRouteData } from "./areas/artboards/atrboard.routes";
// import { profileAreaRouteData } from "./areas/profile/route-data";
// import { ClientRoutePlaceholderComponent } from "./shell/client-route-placeholder/client-route-placeholder.component";
import { clientsHomeRouteData } from '@areas/client-home/client-home.routes';
import { clientsAreaRouteData as clientsAreaRoutes } from '@areas/clients/clients.routes';
import { dataSetsTextRoutes } from '@areas/data-sets-text';
import { developerAreaRouteData as developerAreaRoutes } from '@areas/developer/developer.routes';
import { digOMaticRoutes } from '@areas/dig-o-matic/digomatic.routes';
import { imageDefinitionsRouteData } from '@areas/image-definitions-new/image-definitions-new.routes';
import { AuthGuard } from '@auth0/auth0-angular';
import { InlightsRoute } from '@shared/models/shell/InlightsRoute';
import { authAreaRouteData as authAreaRoutes } from './auth/auth.routes';
import { ClientContextNullComponent } from './shell/client-context-null/client-context-null.component';
import { ClientContextComponent } from './shell/client-context/client-context.component';
import { userManagementRoutes } from '@areas/user-management/user-mangement.routes';
import { dataSetsImageRoutes } from '@areas/data-sets-image';
import { fontsRoutes } from '@areas/fonts/font.routes';

// Although one may expect loadChildren to be used in the route data, as the imported route segments only lazy load componetns and do not import them, this should still be fine.
// It alos lets us store data that we can use in the navigation service that can be accessed without having to load the route segment.

export const clientRoutes: InlightsRoute[] = [
	...clientsHomeRouteData,
	...imageDefinitionsRouteData,
	...imageJobsRoutes,
	...clientImageTemplatesRouteData,
	...dataSetsTextRoutes,
	...dataSetsImageRoutes,
];

export const nonClientRoutes: InlightsRoute[] = [
	...clientsAreaRoutes,
	...developerAreaRoutes,
	...authAreaRoutes,
	...fontsRoutes,
	...digOMaticRoutes,
	...userManagementRoutes,
	// { path: 'dig', loadChildren: () => import('@areas/dig-o-matic/digomatic.routes').then(m => m.digOMaticRoutes) },
];

export const routes: InlightsRoute[] = [
	{
		title: "Test",
		path: "techtest",
		loadComponent: () => import('@areas/tech-test/tech-test.component').then(m => m.TechTestComponent),
	},
	{
		title: "Inlights Home",
		path: "",
		component: ClientContextNullComponent,
		children: nonClientRoutes,
		canActivate: [
			AuthGuard,
		],
	},
	{
		path: ":clientId",
		component: ClientContextComponent,
		canActivate: [
			AuthGuard,
		],
		children: clientRoutes,
		title: 'Client',
		data: {
			allowAnonymousAccess: false,
			requiredClaims: [],
		},
	}
];
